import { ref } from 'vue'

export const swUpdateAvailable = ref(false)
// Nova versão pronta e aguardando para ser aplicada automaticamente
export const swUpdateReady = ref(false)
let _waitingWorker: ServiceWorker | null = null
let _applying = false

export function setWaitingWorker(sw: ServiceWorker) {
  _waitingWorker = sw
  swUpdateAvailable.value = true
  swUpdateReady.value = true
}

// Aplica a atualização pendente com segurança (usado pelo auto-update).
// Retorna true se iniciou a aplicação. Reload acontece no controllerchange.
export function applyPendingUpdateSafely(): boolean {
  if (!swUpdateReady.value || _applying) return false
  _applying = true
  applySwUpdate()
  return true
}

// Tell the waiting SW to take control, then reload once it does
export function applySwUpdate() {
  if (_waitingWorker) {
    _waitingWorker.postMessage({ type: 'SKIP_WAITING' })
  }
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload()
  }, { once: true })
  // Fallback if no waiting worker (shouldn't happen)
  if (!_waitingWorker) window.location.reload()
}

// Hard reset: unregister SW + clear all caches + reload
export async function forceHardReload() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(r => r.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
  } catch (_) { /* ignore — reload anyway */ }
  window.location.reload()
}
